exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cursor-pointer[data-v-5a6f7c9a]{cursor:pointer}.product-card[data-v-5a6f7c9a]{transition:transform .2s}.transition-transform[data-v-5a6f7c9a]{transition:transform .3s ease}.product-card:hover .transition-transform[data-v-5a6f7c9a]{transform:scale(1.05)}.product-card[data-v-5a6f7c9a]:hover{transform:translateY(-5px);box-shadow:0 4px 15px rgba(0,0,0,.1)}", ""]);

// exports
